import { render, staticRenderFns } from "./DashBoardSettings.vue?vue&type=template&id=3a87f60c"
import script from "./DashBoardSettings.vue?vue&type=script&lang=js"
export * from "./DashBoardSettings.vue?vue&type=script&lang=js"
import style0 from "./DashBoardSettings.vue?vue&type=style&index=0&id=3a87f60c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports